<template>
  <div v-if="errors.length || message" class="error">
    <p class="title">Oh No! 😮 {{ titleText }}</p>

    <div class="px-6">
      <p v-if="message" class="message">
        {{ message }}
      </p>

      <ul v-if="errors.length" class="list">
        <li v-for="(error, i) in errors" :key="i" class="list-item">
          {{ checkNetworkError(error) | formatError }}
        </li>
      </ul>

      <p v-if="errorHint" class="error-hint">
        {{ errorHint }}
      </p>
    </div>

    <Button
      v-if="errorAction && errorActionLabel"
      class="primary mx-auto sm mt-4"
      @click="errorAction"
    >
      {{ errorActionLabel }}
    </Button>
  </div>
</template>

<script>
import has from "lodash.has";

export default {
  name: "Error",

  filters: {
    formatError(error) {
      if (has(error, "message")) {
        return error.message;
      }

      return error;
    },
  },
  props: {
    errors: {
      default: () => [],
      type: Array,
    },
    errorAction: {
      default: null,
      required: false,
      type: Function,
    },
    errorActionLabel: {
      default: "",
      required: false,
      type: String,
    },
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      errorHint: "",
    };
  },
  computed: {
    titleText() {
      return this.errors.length === 1
        ? "Sorry there is an error!"
        : "Sorry there are some errors!";
    },
  },
  methods: {
    checkNetworkError(error) {
      if (
        this.$has(error, "message") &&
        error.message === "Network error: Failed to fetch"
      ) {
        this.errorHint = "Are you connected to the internet?";
      }

      return error;
    },
  },
};
</script>

<style scoped>
.error {
  @apply border border-grey-lighter rounded-lg p-2 shadow bg-grey-lightest text-center;

  @screen sm {
    @apply text-sm p-4;
  }

  @screen md {
    @apply p-4;
  }
}

.error-hint {
  @apply text-xs italic text-grey-dark mt-2;

  @screen md {
    @apply text-sm;
  }
}

.title {
  @apply bg-danger rounded-lg text-white p-2 text-base mb-4 font-lato;

  @screen md {
    @apply text-base;
  }
}

.message {
  @apply text-center text-sm text-support mb-4 font-bold;

  @screen md {
    @apply text-sm;
  }
}

.list {
  @apply list-reset m-0 mb-4 text-center max-w-sm mx-auto;
}

.list-item {
  @apply mb-2 text-sm text-support;

  @screen md {
    @apply text-sm;
  }

  &:last-child {
    @apply mb-0;
  }
}
</style>
